export async function fetchJson(url, options = {}) {
  const response = await fetch(url, options);
  const text = await response.text();

  let data = null;
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (error) {
      throw new Error(`Invalid JSON response from server (${response.status})`);
    }
  }

  if (!response.ok) {
    const message = data?.message || `HTTP error: ${response.status}`;
    throw new Error(message);
  }

  if (data === null) {
    throw new Error('Server returned an empty response');
  }

  return data;
}
